/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

const OPEN_CART_DRAWER_FLAG = 'theme-open-cart-drawer';

function openCartDrawer() {
  /** @type {HTMLElement & { open?: () => void } | null} */
  const drawer = document.querySelector('theme-drawer#cart-drawer');

  if (!drawer?.open) return false;

  drawer.open();
  return true;
}

function maybeOpenCartDrawerAfterRedirect() {
  if (sessionStorage.getItem(OPEN_CART_DRAWER_FLAG) !== '1') return;
  sessionStorage.removeItem(OPEN_CART_DRAWER_FLAG);

  if (openCartDrawer()) return;

  customElements.whenDefined('theme-drawer').then(openCartDrawer);
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) {
    maybeOpenCartDrawerAfterRedirect();
    return;
  }

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (!openCartDrawer()) {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });

  maybeOpenCartDrawerAfterRedirect();
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
